// detect when the user scrolls down. used for mobile CTA buttons at bottom of screen and the sticky nav

// use a simple throttle

function throttle(callback, limit) {
	let wait = false;
	return function (...args) {
		if (!wait) {
			callback(...args);
			wait = true;
			setTimeout(function () {
				wait = false;
			}, limit);
		}
	};
}

// watch for scrolling

const html = document.querySelector('html');

let prevScrollpos = window.pageYOffset;
window.onscroll = throttle(() => {
	const currentScrollPos = window.pageYOffset;
	if (html.classList.contains('mobile-menu-active')) {
		return;
	}
	if (html.classList.contains('no-scrolldown')) {
		return;
	}
	if (prevScrollpos > currentScrollPos) {
		html.classList.remove('scrolled-down');
	} else {
		html.classList.add('scrolled-down');
	}
	prevScrollpos = currentScrollPos;
}, 400);
